// Chart colours are set explicitly (never recharts defaults) and mirror tailwind.config.js.
// One accent for "this video" (brand-yellow), a muted neutral for "everyone else".
// Refund figures use REFUND_TEXT (muted battle-red-light) everywhere in the panel.
export const SALES_COLORS = {
  accent: '#F5E642', // brand-yellow
  accentFill: 'rgba(245,230,66,0.18)',
  neutral: '#596150', // muted olive-grey (>=3:1 against the card surface) for "all other videos"
  grid: 'rgba(95,117,72,0.22)', // army-light at low alpha
  axis: '#7C8471',
  surface: '#141710', // battle-gray
  refund: '#EF4444', // battle-red-light, used muted (refund figures only)
};

// Tailwind classes for refund figures and badges (muted red, readable on battle-gray).
export const REFUND_TEXT = 'text-battle-red-light/80';
export const REFUND_BADGE =
  'inline-flex items-center shrink-0 rounded px-1.5 py-px text-[10px] font-semibold uppercase tracking-wide leading-4 border border-battle-red/40 bg-battle-red/10 text-battle-red-light/90';
